import React, { Component, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, Label, Button, Alert,
         Modal, ModalHeader, ModalBody, Form, FormGroup, Input} from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { Loading, LoadingParams, AccessDenied, Checking } from './LoadingComponent';
import { connect } from 'react-redux';
import { RenderVirtualTable, RenderEditableVirtualTable } from './TableComponent';
import { S3Uploader } from './S3UploaderComponent';
import { toPerc, toFloat, sleep, CustomListSelect } from './Functions';
import { suit_files } from '../shared/data';
import { CSVLink } from "react-csv";
import Select from 'react-select';
import { postRequest, runJob, validateFile } from '../redux/ActionCreators';

// import 'rsuite/dist/styles/rsuite-default.css';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    suit_params: state.suit_params
  };
};

class Suitability extends Component {
    constructor(props){
        super(props);
        this.state = {
            msg:null,
            loading_metrics:false,
            checking_status:false,
            sending_request:false,
            suit_form:false,
            edit_table:false
        };
        this.runSuit = this.runSuit.bind(this);
        this.verifyStatus = this.verifyStatus.bind(this);
        this.loadTable = this.loadTable.bind(this);
        this.updateTable = this.updateTable.bind(this);
        this.toggle = this.toggle.bind(this);
    }
    // }

    async loadTable(){
      try {
        this.setState({
          loading_metrics:true
        });
        const suit_table = await postRequest({
          bucket:'condor-sura-wm', 
          key:suit_files.find(k=>k.name==this.props.suit_params.table_name).key, //"suitability/input/static/pe/matricesRiesgoPE.csv", 
          sep:',',
        }, 'retrieve_data_s3');
        
        await this.props.changeModel('suit_params.table_data', suit_table);
        await this.props.changeModel('suit_params.table_id', this.props.suit_params.table_name);
        this.setState({
          loading_metrics:false,
          msg:"Tabla cargada"
        });
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          loading_metrics:false,
          msg: error.message
        });
      }
    }

    async updateTable(){
      try {
        this.setState({
          loading_metrics:true
        });
        const udt_suit_table = await postRequest({
          bucket:'condor-sura-wm', 
          file_name:suit_files.find(k=>k.name==this.props.suit_params.table_name).key, //"suitability/input/static/pe/matricesRiesgoPE.csv", 
          sep:',',
          overwrite:true,
          payload:this.props.suit_params.table_data
        }, 'load_data_s3');
        console.log(udt_suit_table);
        this.setState({
          loading_metrics:false,
          msg:"Tabla actualizada"
        });
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          loading_metrics:false,
          msg: error.message
        });
      }
    }

    async runSuit(e){
      e.preventDefault();
      const form = e.target;
      try {
        this.setState({sending_request:true});
        const resp_embed = await runJob({
          jobname:"job_exposure_pe", 
          add_args:{
            "--send_email":form.user_email.value,
            "--bucket_positions":"condor-sura-wm",
            "--key_positions":"suitability/input/temp/pe/"+this.props.suit_params.filename,
            "--key_limits":"suitability/input/temp/pe/matrixLimitsExposure.csv"
          }}).then(res=>res.json());
        if (resp_embed.status=="RUNNING"){
          this.setState({
            msg:"Proceso en ejecución. En unos minutos llegará el reporte al correo " + form.user_email.value,
            suit_form:false,
            sending_request:false
          });
          this.props.changeModel("suit_params.run_id_value", resp_embed.id);
        } else if (resp_embed.status=="error"){
          this.setState({
            msg:"No se puede iniciar proceso. Posiblemente ya existe un proceso en curso. Intente de nuevo en unos minutos",
            suit_form:false,
            sending_request:false
          });
        }
      } catch (error) {
        console.log(error.message);
        this.setState({
          sending_request:false,
          msg: error.message,
          suit_form:false
        });
      }
    }

    async verifyStatus(){
      this.setState({checking_status:true});
      try {
        if (this.props.suit_params.run_id_value!==""){
          const resp_embed = await runJob({
            jobname:"job_exposure_pe", 
            job_id:this.props.suit_params.run_id_value
          }).then(res=>res.json());
          console.log(resp_embed);
          this.setState({
            checking_status:false,
            msg:resp_embed.status=="RUNNING" ? "Se está ejecutando proceso. Por favor espere correo con el reporte" : "No se está ejecutando proceso de suitability. El último proceso terminó con estatus "+resp_embed.status ,
          });
        }else{
          this.setState({
            checking_status:false,
            msg:"No se está ejecutando proceso de suitability.",
          });
        }
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          checking_status:false,
          msg: error.message,
        });
      }
    }
    
    toggle(){
      if (this.props.suit_params.filename==null || this.props.suit_params.filename==""){
        this.setState({msg:"No se ha cargado archivo de portafolio."});
      } else {
        this.setState({suit_form:!this.state.suit_form});
      }
    }

    render(){
        if(this.state.loading_metrics){
          return(
              <div className="container">
                <div className="row justify-content-center">
                  <Loading />
                </div>
              </div>
          );
        } else {
            return(
                <div className="container">
                    <div className="row m-3 justify-content-center">
                      <div className="col-auto">
                        <Breadcrumb>
                          <BreadcrumbItem active>Proceso</BreadcrumbItem>
                          <BreadcrumbItem><Link to='/suitability/report'>Reporte</Link></BreadcrumbItem>
                        </Breadcrumb>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-9">
                          <div className="row justify-content-center" id="init">
                              <div className="col-12 mt-4">
                                  <h5><center>Ejecución Proceso de Suitability</center></h5>
                              </div>
                          </div>
                          {this.props.suit_params.filename ?
                          <div className="row justify-content-center">
                              <div className="col-6">
                                  <p><center>Último archivo cargado: <i>{this.props.suit_params.filename}</i></center></p>
                              </div>
                          </div>
                          :null
                          }
                          <div className="row m-3 justify-content-center">
                              <div className="col-6 m-2">
                                  <S3Uploader
                                    bucket="condor-sura-wm"
                                    dir="suitability/input/temp/pe/"
                                    button_label="Cargar Posiciones"
                                    validator={validateFile}
                                    filename_var="suit_params.filename"
                                    changeModel={this.props.changeModel}
                                    other_params={{"cty":"PE"}}
                                  />
                              </div>
                          </div>
                          <div className='row justify-content-center align-items-end m-4'>
                            <div className='col-5'>
                              <label><small>Parámetros</small></label>
                              <CustomListSelect
                                options={suit_files.map(k=>k.name).map(x=>{
                                  return {value:x, label:x};
                                })}
                                maxMenuHeight={100}
                                isClearable={true}
                                value={this.props.suit_params.table_name==null ? null : {value:this.props.suit_params.table_name, label:this.props.suit_params.table_name}}
                                onChange={(e)=>this.props.changeModel("suit_params.table_name", e==null ? null : e.value)}
                                itemSize={50}
                                className="basic-single"
                                placeholder="seleccionar tabla"
                              />
                            </div>
                          </div>
                          <div className="row justify-content-center mt-5">
                              <div className='col-auto'>
                                  <Button 
                                      className="btn-corp"
                                      onClick={this.loadTable}>
                                      Ver tabla
                                  </Button>
                              </div>
                              <div className='col-auto'>
                                  <Button 
                                      className="btn-corp"
                                      onClick={this.toggle}>
                                        Ejecutar Suitability
                                  </Button>
                              </div>
                              {this.state.checking_status ?
                              <div className='col-3'>
                                  <Checking />
                              </div>
                              :
                              <div className='col-auto'>
                                  <Button 
                                      className="btn-corp"
                                      onClick={this.verifyStatus}>
                                        Verificar Estado
                                  </Button>
                              </div>
                              }
                          </div>
                          <Modal isOpen={this.state.suit_form} toggle={this.toggle}>
                            <ModalHeader toggle={this.toggle}>Suitability</ModalHeader>
                            <ModalBody>
                              <Form onSubmit={this.runSuit}>
                                <div className="row">
                                  <div className="col">
                                    <FormGroup>
                                      <Label for="name">Correo</Label>
                                      <Input 
                                        type="email" 
                                        id="user_email" 
                                        className="mb-3" />
                                    </FormGroup>
                                  </div>
                                </div>
                                <div className="row">
                                {this.state.sending_request ?
                                  <div className='col-3'>
                                      <Checking />
                                  </div>
                                :
                                  <div className='col-auto'>
                                    <Button color="primary" type="submit">
                                      Enviar solicitud
                                    </Button>                                  </div>
                                }
                                  <div className='col-auto'>
                                  <Button color="secondary" onClick={this.toggle}>
                                    Cancelar
                                  </Button>
                                  </div>
                                </div>
                              </Form>
                            </ModalBody>  
                          </Modal>
                          
                          {this.state.msg!=='' && this.state.msg!==null ?
                            <div className="row mt-4 justify-content-center">
                              <div className="col-6 m-3">
                                <Alert
                                  color={this.state.msg.includes('Error') ? 'danger':'secondary'}
                                  isOpen={this.state.msg!=='' && this.state.msg!==null} 
                                  toggle={()=>this.setState({msg:null})}>
                                    {this.state.msg}
                                </Alert>
                              </div>
                            </div>
                            :<></>
                          }
                          
                          {this.props.suit_params?.table_data && this.props.suit_params?.table_data.length>0 ?
                          <>
                            <div className="row m-4 justify-content-center">
                              <div className='col'>
                                <hr></hr>
                              </div>
                            </div>
                            <div className="row m-4 justify-content-center" id="params">
                              <div className='col'>
                                <h5>Tabla de Parámetros</h5>
                                <a className='linkcol' href='#init'>volver&uarr;</a>
                              </div>
                            </div>
                            {suit_files.find(k=>k.name==this.props.suit_params.table_id).editable ?
                            <div className="row m-4 justify-content-center">
                              <div className='col-2'>
                                <Label check>
                                  <Input type="checkbox"
                                    checked={this.state.edit_table}
                                    onChange={()=>this.setState({edit_table:!this.state.edit_table})}
                                    />{' '}
                                    Editar tabla
                                </Label>
                              </div>
                            </div>
                            :null
                            }
                            <div className="row mt-4 justify-content-center">
                              <div className={"col-"+String(Object.keys(this.props.suit_params.table_data[0]).length+2)}>
                                <RenderEditableVirtualTable 
                                  data={this.props.suit_params.table_data}
                                  change_model={this.props.changeModel}
                                  model_id={"suit_params.table_data"}
                                  editable={this.state.edit_table ? [false, false, true, true, true] : null}
                                  fontsize={12}
                                />
                              </div>
                            </div>
                            {suit_files.find(k=>k.name==this.props.suit_params.table_id).editable ?
                            <div className="row m-4 justify-content-center">
                              <div className='col-auto'>
                                <Button
                                  className="btn-corp"
                                  onClick={this.updateTable}>
                                  Actualizar tabla
                                </Button>
                              </div>
                            </div>
                            :null
                            }
                            <div className="row m-4 justify-content-center">
                              <div className='col-auto'>
                                <CSVLink className='link-btn' data={this.props.suit_params.table_data} filename="tabla"><small>Descargar tabla&darr;</small></CSVLink>
                              </div>
                            </div>
                          </>
                          :null
                            
                          }
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(connect(mapStateToProps)(Suitability));
